import { useState } from 'react';

import type { DailySalesDay } from '../../../../api/daily-sales';
import { SegmentedControl } from '../../primitives';
import { formatMoney, formatMoneyAxis, windowSum, type SourceKey } from '../daily-sales-format';

import { DailySalesChart } from './DailySalesChart';

type RevenueBasis = 'grossCents' | 'subtotalCents';

const REVENUE_BASES = [
  { value: 'grossCents', label: 'Gross payment' },
  { value: 'subtotalCents', label: 'Pre-tax' },
] as const;

interface DailySalesRevenueChartProps {
  days: DailySalesDay[];
  today: string;
  sources: SourceKey[];
}

export function DailySalesRevenueChart({ days, today, sources }: DailySalesRevenueChartProps) {
  const [basis, setBasis] = useState<RevenueBasis>('grossCents');

  return (
    <DailySalesChart
      days={days}
      today={today}
      title="Revenue per day"
      sources={sources}
      measure={basis}
      format={formatMoney}
      axisFormat={formatMoneyAxis}
      aside={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span className="nb-ds-meta">
            {formatMoney(windowSum(days, basis, sources))}{' '}
            {basis === 'grossCents' ? 'gross' : 'pre-tax'}
          </span>
          <SegmentedControl
            value={basis}
            onChange={setBasis}
            options={REVENUE_BASES}
            ariaLabel="Revenue basis"
          />
        </div>
      }
    />
  );
}
